<template>
	<Bar :chart-data="chartData" :chart-options="chartOptions" class="bar-chart-container flex-centerize px-2" />
</template>

<script>
// Util
function getDayName(dateStr, locale) {
	var date = new Date(dateStr);
	return date.toLocaleDateString(locale, { weekday: 'long' });
}
import Bar from '@/components/Charts/Bar.vue';
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
export default {
	name: 'AnalyticsTotalRunsBar',
	mixins: [AnalyticsMixin],
	components: { Bar },
	computed: {
		chartData() {
			return {
				labels: this.labels,
				datasets: [{ label: 'Runs by day', backgroundColor: '#9A69FA', data: this.allRunsLinearArr }],
			};
		},
		labels() {
			return this.allDaysLinearArr.map((date) => {
				const arr = date.split('-');
				return `${arr[1]}/${arr[2]}`; // MM/DD
			});
		},
		chartOptions() {
			return {
				responsive: true,
				maintainAspectRatio: true,
				plugins: {
					legend: { display: false },
					tooltip: {
						enabled: true,
						callbacks: {
							beforeBody: (contexts) => {
								const context = contexts[0];
								const data = this.allDaysLinearArr[context.dataIndex];

								const dayOfWeek = getDayName(data, 'en-US');
								return dayOfWeek;
							},
						},
					},
				},
				scales: { x: { grid: { display: false } } },
			};
		},
	},
};
</script>
<style scoped lang="scss"></style>
